import React from "react";

export default function Footer() {
    return (
        <footer
            style={{
                width: "100%",
                padding: "14px 18px",
                marginTop: "16px",
                borderTop: "2px solid #FFFF00",
                backgroundColor: "#000",
                color: "#FFFF00",
                fontSize: "13px",
                fontWeight: "bold",
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: "14px",
                textAlign: "center",
            }}
        >
            <span style={{ cursor: "pointer" }}>Privacy Policy</span>
            <span style={{ cursor: "pointer" }}>Terms &amp; Conditions</span>
            <span style={{ cursor: "pointer" }}>About Us</span>
            <span style={{ cursor: "pointer" }}>Contact</span>
            <span style={{ cursor: "pointer" }}>Help/FAQ</span>
            <span style={{ cursor: "pointer" }}>Social Media</span>
            <span style={{ opacity: 0.9 }}>Copyright © 2025</span>
        </footer>
    );
}
